export default defineNuxtRouteMiddleware((to) => {
  const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const tenantId = to.params.tenantId as string;

  if (!guidRegex.test(tenantId)) {
    // Trigger default 404 handling
    console.error(`Invalid tenantId: ${tenantId}`);
    return abortNavigation();
  }
});